module.exports = __webpack_public_path__ + "img/org02.e1d60079.png";